import { useMemo } from 'react';

import { useSite } from '@labradorsports/utils';

import * as Assets from './images.js';

export default function useAssets() {
    const {
        env: { cdnUrl },
    } = useSite();

    return useMemo(() => {
        return {
            ...Object.fromEntries(
                Object.entries(Assets).map(([name, getter]) => {
                    return [name, getter(cdnUrl)];
                })
            ),
        };
    }, []);
}
